import { Fragment } from "react";
import "./HomeworkInstruction.scss";
import images from "../../../../../../utilities/images/images";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const HomeworkInstruction = (props) => {
  let { testDetails, startBtn, testSectionsDetails } = props;

  const testPaperId = useSelector(
    (state) => state.HomeWorkSlice.homeworkTestDetails.id
  );

  function testTime(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    return h + ":" + m + " hrs";
  }

  const renderButtonType = () => {
    return "Start Test";
  };

  return (
    <Fragment>
      <div className="exam_section_test_intructions_view_wrapper">
        <div className="container">
          <div className="test_intructions_view_inner_wrapper">
            <div className="instructionScreenBox">
              <Link
                className="backBtn"
                to={{
                  pathname: "/dashboard",
                  // state: { tab: "exam" },
                }}
              >
                <img src={images.m2_backBtn} alt="backBtn" />
              </Link>
              <div className="instruction_title">Instruction Screen</div>
              <div className="instruction_detailBox">
                <div className="examTime">
                  <div className="examTitle">Homework</div>
                </div>
                <div className="instructions">
                  <h3>Set of Instructions</h3>
                  <div className="instPoint">
                    {/* <div className="img">
                      <img
                        src={`https://quizmaster.motion.ac.in${testDetails.instructions_image}`}
                        alt="instructions_image"
                      />
                    </div> */}
                    <p>This Section contains a set of questions for practice</p>
                    <p>
                      Users can go to previous question by clicking on the
                      previous button
                    </p>
                    <p>
                      Users can go to next question by clicking on the next
                      button
                    </p>
                    <h6>Best of luck</h6>
                  </div>
                </div>
                <div className="startTestBtn">
                  <button onClick={() => startBtn()}>
                    {renderButtonType()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomeworkInstruction;
